import type { IStore } from '../../../stores/Store';
import updateBucketAndRefreshPage from './updateBucketAndRefreshPage';
import { fetchApplicationStatusFolderByAdcentreProspectId } from 'src/graphql/fetchApplicationStatusFolderByAdcentreProspectId.hirer.graphql';
import { mapToBucket } from 'src/stores/JobApplicationStore/utils/mapApiResponseToStore';

const changeBucketForSelectedJobApplication = async (
  store: IStore,
  jobId: number,
  selectedProspectId: string,
) => {
  const {
    result: { statusFolder },
  } = await fetchApplicationStatusFolderByAdcentreProspectId({
    input: {
      adcentreProspectId: selectedProspectId,
      jobId,
    },
  });

  const bucket = mapToBucket(statusFolder);
  if (bucket !== store.jobApplicationStore.bucket) {
    updateBucketAndRefreshPage(bucket);
  }
};

export default changeBucketForSelectedJobApplication;
